import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export default function RequireAuth({ children }) {
  const {isAuthenticated} = useAuth0(); 
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}